//
// Copyright (c) 2023 Emplifi, Inc.
//

import i18next from "i18n/i18n";
import { Plugin } from "ckeditor5";

export default class SpecialCharactersExtended extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get requires() {
    return ["SpecialCharacters"];
  }

  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "SpecialCharactersExtended";
  }

  init() {
    this.editor.plugins.get("SpecialCharacters").addItems("Text", [
      { title: i18next.t("ckeditor.character.singleDagger"), character: "†" },
      { title: i18next.t("ckeditor.character.accentEAigue"), character: "é" },
      { title: i18next.t("ckeditor.character.accentAGrave"), character: "à" },
      { title: i18next.t("ckeditor.character.accentEGrave"), character: "è" },
      { title: i18next.t("ckeditor.character.accentUGrave"), character: "ù" },
      { title: i18next.t("ckeditor.character.cedilla"), character: "ç" },
      { title: i18next.t("ckeditor.character.accentACircumflex"), character: "â" },
      { title: i18next.t("ckeditor.character.accentECircumflex"), character: "ê" },
      { title: i18next.t("ckeditor.character.accentICircumflex"), character: "î" },
      { title: i18next.t("ckeditor.character.accentOCircumflex"), character: "ô" },
      { title: i18next.t("ckeditor.character.accentUCircumflex"), character: "û" },
      { title: i18next.t("ckeditor.character.accentETrema"), character: "ë" },
      { title: i18next.t("ckeditor.character.accentITrema"), character: "ï" },
      { title: i18next.t("ckeditor.character.accentUTrema"), character: "ü" },
      { title: i18next.t("ckeditor.character.aUmlaut"), character: "ä" },
      { title: i18next.t("ckeditor.character.oUmlaut"), character: "ö" },
      { title: i18next.t("ckeditor.character.eszett"), character: "ẞ" },
      { title: i18next.t("ckeditor.character.accentEAigueCapital"), character: "É" },
      { title: i18next.t("ckeditor.character.accentAGraveCaptial"), character: "À" },
      { title: i18next.t("ckeditor.character.accentEGraveCapital"), character: "È" },
      { title: i18next.t("ckeditor.character.accentUGraveCapital"), character: "Ù" },
      { title: i18next.t("ckeditor.character.cedillaCapital"), character: "Ç" },
      { title: i18next.t("ckeditor.character.accentACircumflexCapital"), character: "Â" },
      { title: i18next.t("ckeditor.character.accentECircumflexCapital"), character: "Ê" },
      { title: i18next.t("ckeditor.character.accentICircumflexCapital"), character: "Î" },
      { title: i18next.t("ckeditor.character.accentOCircumflexCapital"), character: "Ô" },
      { title: i18next.t("ckeditor.character.accentUCircumflexCapital"), character: "Û" },
      { title: i18next.t("ckeditor.character.accentETremaCapital"), character: "Ë" },
      { title: i18next.t("ckeditor.character.accentITremaCapital"), character: "Ï" },
      { title: i18next.t("ckeditor.character.accentUTremaCapital"), character: "Ü" },
      { title: i18next.t("ckeditor.character.aUmlautCapital"), character: "Ä" },
      { title: i18next.t("ckeditor.character.oUmlautCapital"), character: "Ö" },
    ]);
  }
}
